import { Session } from '../session/session.model';

export class Evaluation {
    constructor(
        public id: number,
        public date: any,
        public trainerAnswerQuality: number,
        public trainerAvailability: number,
        public trainerPedagogicalQuality: number,
        public trainerSubjectKnowledge: number,
        public trainingContentRichness: number,
        public trainingExamples: number,
        public trainingLayout: number,
        public trainingPracticeInterest: number,
        public trainingTheoryPracticeRatio: number,
        public trainingSession: Session,

        public studentId?: number,
        public studentFullName?: string,
        public trainerFullName?: string,
        public version?: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/evaluation/evaluation.model.ts